module.exports = __webpack_public_path__ + "img/portugal-pneumonia-female.03b2c65e.png";